import { useContext } from "react";

import { ResourcesContext } from "./ResourcesContext";

export const useResourcesContext = () => useContext(ResourcesContext);
